import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme-context";

export default function ThemeToggle({ className = "", size = "sm" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      onClick={toggleTheme}
      data-testid="theme-toggle-button"
      aria-label={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      title={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      className={`gap-1.5 justify-center whitespace-nowrap md:min-w-[92px] ${className}`}
    >
      {isDark ? <Sun size={16} strokeWidth={1.75} /> : <Moon size={16} strokeWidth={1.75} />}
      <span className="hidden md:inline text-xs tabular-nums">{isDark ? "Claro" : "Oscuro"}</span>
    </Button>
  );
}
